import React, { useState, useEffect } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

interface AgentConnectionOverlayProps {
  show: boolean;
  agentConnected: boolean;
  onComplete?: () => void;
}

export const AgentConnectionOverlay: React.FC<AgentConnectionOverlayProps> = ({
  show
}) => {
  const [message, setMessage] = useState("Connecting to AI interviewer...");
  const [startTime, setStartTime] = useState(() => Date.now());

  // Reset timer whenever overlay becomes visible
  useEffect(() => {
    if (show) {
      setStartTime(Date.now());
    }
  }, [show]);

  useEffect(() => {
    if (!show) return;

    const updateMessage = () => {
      const elapsed = Date.now() - startTime;
      const newMessage = elapsed < 10000 
        ? "Connecting to AI interviewer..."
        : "AI interviewer is getting ready...";
      setMessage(newMessage);
    };

    // Update immediately and every second
    updateMessage();
    const interval = setInterval(updateMessage, 1000);

    return () => clearInterval(interval);
  }, [show, startTime]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 text-center shadow-2xl">
        <LoadingSpinner size="lg" className="mb-4" />
        <h3 className="text-xl font-semibold text-gray-800">
          {message}
        </h3>
      </div>
    </div>
  );
};
